export const SET_CONTEXT_PAGE_COUNT = 'SET_CONTEXT_PAGE_COUNT';
export const GET_CONTEXT_PAGE_COUNT = 'GET_CONTEXT_PAGE_COUNT';
